import React from 'react'
import PropTypes from 'prop-types'
import { Div, Label, Input, TextArea, Span } from 'styled-system-html'

const getFormControl = type => {
  if (type === 'email') {
    return 'TEXT'
  } else {
    return type.toUpperCase()
  }
}

const FormControl = props => (
  <Div pb={2}>
    <Label fontSize={1} fontWeight="500" pb={1} display="block" htmlFor={props.id}>
      {props.label}
      {props.labelAddendum ? (
        <Span fontWeight={300} fontSize={0} pl={1}>
          {' '}
          {props.labelAddendum}
        </Span>
      ) : (
        ''
      )}
    </Label>
    <>
      {
        {
          TEXT: (
            <Input
              type={props.type}
              name={props.id}
              onChange={e => props.setValue(e.target.value)}
              required
              width={1}
              mb={3}
              value={props.value}
            />
          ),
          TEXTAREA: (
            <TextArea
              name={props.id}
              onChange={e => props.setValue(e.target.value)}
              required
              width={1}
              mb={3}
              value={props.value}
              rows="8"
            />
          ),
          CUSTOM: <>{props.children}</>,
        }[getFormControl(props.type)]
      }
    </>
  </Div>
)

FormControl.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelAddendum: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
}

export default FormControl
